import {
  Component,
  OnInit,
  HostListener,
  ViewChild,
  ViewChildren,
  QueryList,
  Pipe,
  PipeTransform,
  OnDestroy,
  NgZone
} from '@angular/core';
import { AuthenticationService } from '../../shared/authentication.service';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import {Observable, Timestamp, BehaviorSubject, Subscription, Subject} from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../shared/api.service';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import * as moment from 'moment';
import { AngularFireAuth } from '@angular/fire/auth';
import { MatDrawer } from '@angular/material/sidenav';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import * as firebase from 'firebase';
import { CacheService } from '../../shared/cache.service';
import { EbiService } from '../../shared/ebi.service';
import {MatPaginator} from '@angular/material/paginator';
import {array, number, string} from '@amcharts/amcharts4/core';
import * as JSZip from 'jszip';
/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

export interface Item {
  uid: any;
  location: any;
  note: any;
  waterSource: any;
  calculationResult: any;
}
export interface ITestsDoc {
  uid: string;
  status: number;
  date: {
    _seconds: number;
    _nanoseconds: number;
  };
  isArchived?: boolean;
  calculationResult: {
    deviceMacAddress: string;
    geoip: {
      area: number;
      eu: string;
      ll: [number, number];
      country: string;
      city: string;
      metro: number;
      timezone: string;
      range: [number, number];
      region: string;
    };
    eColiLevel: number;
    ip: string;
    testType: string;
    eColiStage1Date: {
      _seconds: number;
      _nanoseconds: number;
    };
    eColiStage1AvgData: {
      b: number;
      r: number;
      c: number;
      g: number;
    };
    testId: string;
    eColiStage2AvgData: {
      b: number;
      r: number;
      c: number;
      g: number;
    };
    eColiStage2Date: {
      _seconds: number;
      _nanoseconds: number;
    };
    date: {
      _seconds: number;
      _nanoseconds: number;
    };
    gSlope: number;
    confidence: string;
    eColiStage3Date: {
      _seconds: number;
      _nanoseconds: number;
    };
    description: string;
    eColiStage: number;
    endFrame: number;
    error: boolean;
    slope: number;
    startFrame: number;
    gConfidence: number;
    metric: string;
    ecoliTestComplete: boolean;
    textDescription: string;
  };
  note?: string;
  location?: {
    formatted_address: string;
    lng: number;
    name: string;
    lat: number;
    place_id: string;
    waterSource: string;
  };
}
export interface ILocation {
  waterSourcesArray: Array<string>;
  locationArray: Array<string>;
}

@Pipe({name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@Component({
  selector: 'app-test-list',
  templateUrl: './test-list.component.html',
  styleUrls: ['./test-list.component.css']
})

export class TestListComponent implements OnInit, OnDestroy {
  private userOrgId: string;
  private userFirestoreData: any;
  private userOrgData: any;
  private itemsCollection: AngularFirestoreCollection<Item>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('drawer') drawer: MatDrawer;
  @ViewChild(GoogleMap, {static: false}) map: GoogleMap;
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  @ViewChildren('markerElem') markerElements: QueryList<MapMarker>;

  ALL_ITEMS_OPTION = 10;
  pageSizeOptions = [this.ALL_ITEMS_OPTION];
  displayedColumns: string[] = ['date', 'test', 'note', 'waterSourece', 'GYR', 'details'];
  dataSource: Array<ITestsDoc>;
  items: Observable<Item[]>;
  itemsToDisplay: Array<any>;
  itemsToDisplayFiltered;
  selectedItem: Item;
  searchText: string;
  show = 10;
  isAdmin: boolean;
  uid: string;
  apiUid: string;
  idToken: string;
  isEditing = false;
  currentUserSavedPlaces: Array<any>;
  currentUserSavedWaterSources: Array<any>;
  userRole;
  userFilterList = {};
  typeFilters = {};
  orgFilterList = {};
  isEditingUser = false;
  dateFilters = {
    '7_days': 0,
    '30_days': 0,
    '6_months': 0,
    '1_year': 0
  };
  typeFiltersChosen = [];
  userFiltersChosen = [];
  orgUsersFiltersChosen = [];
  orgFiltersChosen: any[] = [];
  dateFilterChosen: number = null;
  today = new Date();
  timestamp: number;
  itemsSubscription: Subscription;
  resultsString: string;
  locationsList = [];
  waterSourcesList = [];
  showFilterButton = true;
  pageYOffset = window.pageYOffset;
  displayMap;
  routeDataSubscription: Subscription;
  searchTermSubscription: Subscription;
  displayedTestsSubscription: Subscription;
  userSearchTermSubscription: Subscription;
  orgSearchTermSubscription: Subscription;
  markers: Array<any> = [];
  zoom = 5;
  drawerOpened = false;
  infoContent: string;
  markerUrl = '';
  trustedUrl: string | SafeUrl;
  searchTerm$ = new Subject<string>();
  userSearchTerm$ = new Subject<string>();
  orgSearchTerm$ = new Subject<string>();
  waterSource$ = new Subject<string>();
  location$ = new Subject<string>();
  center: { lat: number, lng: number } = {lat: 54.5259614, lng: -105.2551187}; // Generic North America coordinates
  userListDisplayed: {};
  orgListDisplayed: {};
  mobileDrawerOpened = false;
  usersLoaded = false;
  orgsLoaded = false;
  testListLoaded = false;
  currentPage = 0;
  length: number;
  pageLimit = 10;
  showArchivedTests = true;
  showScheduleTests = true;
  waterSourceSubscription: Subscription;
  locationSubscription: Subscription;
  filterLocation = [];
  filterWaterSource = [];
  filterNote = '';
  allLocation: ILocation;
  locationSelected;
  waterSourceSelected;
  testDataTrue = true;
  testChartDataTrue = true;
  arrayRawData = [];

  // Hiding filter button on scroll down

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    if (this.showFilterButton !== window.pageYOffset <= this.pageYOffset) {
      this.showFilterButton = window.pageYOffset <= this.pageYOffset;
      if (document.getElementById('filter-button')) {
        document.getElementById('filter-button').style.bottom = this.showFilterButton ? '5%' : '-50px';
      }
    }
    this.pageYOffset = window.pageYOffset;
  }

  constructor(private firestore: AngularFirestore,
              private authenticationService: AuthenticationService,
              private router: Router,
              private angularFireAuth: AngularFireAuth,
              private apiService: ApiService,
              private route: ActivatedRoute,
              private sanitizer: DomSanitizer,
              private ebi: EbiService,
              public cacheService: CacheService,
              private ebiService: EbiService,
              private zone: NgZone) {
    this.dataSource = new Array<ITestsDoc>(this.pageLimit);
    this.trustedUrl = sanitizer.bypassSecurityTrustUrl(this.markerUrl);
    this.routeDataSubscription = route.data.subscribe(data => {
      this.displayMap = data.displayMap;
    });
    this.today.setHours(0, 0, 0, 0);
    this.timestamp = this.today.getTime() / 1000;
    this.searchTermSubscription = this.searchTerm$.pipe(
      debounceTime(200))
      .subscribe(term => {
        this.searchItems(term);
      });
    this.userSearchTermSubscription = this.userSearchTerm$.pipe(
      debounceTime(200))
      .subscribe(term => {
        this.searchUsers(term);
      });
    this.waterSourceSubscription = this.waterSource$.pipe(
      debounceTime(200))
      .subscribe(term => {
        this.searchOrgs(term);
      });
    this.locationSubscription = this.location$.pipe(
      debounceTime(200))
      .subscribe(term => {
        this.searchOrgs(term);
      });
  }

  ngOnInit(): void {
    this.angularFireAuth.authState.subscribe(async user => {
      if (user && user.uid) {
        const token = await user.getIdTokenResult();
        this.idToken = token.token;
        this.allLocation = await this.apiService.getAllLocation(this.idToken);
        this.filterLocation = this.pureArray(this.allLocation.locationArray);
        this.filterWaterSource = this.pureArray(this.allLocation.waterSourcesArray);
        this.uid = this.authenticationService.userData.uid;
        this.isAdmin = this.authenticationService.isAdmin;
        this.userRole = this.authenticationService.userRole;
        this.userFirestoreData = await this.authenticationService.getUserFirestoreData();
        // tslint:disable-next-line:max-line-length
        this.userOrgData = await this.authenticationService.getUserOrgData(this.userFirestoreData.data.orgData?.orgId || this.userFirestoreData.data.orgId);
        this.userOrgId = await this.authenticationService.getUserOrgId();
        if (this.cacheService.testListCached) {
          this.getCache();
          this.getTestFiltersData();
          if (!this.userListDisplayed) {
            await this.getUserListData();
          }
          if (this.userRole === 'superuser' && !this.orgListDisplayed) {
            await this.getOrgListData();
          }
          // if markers were not cached previously (coming from non-map test list on first load)
          if (this.markers.length === 0 && this.itemsToDisplayFiltered.length > 0) {
            this.loadMarkers();
            const mostRecentTest = this.itemsToDisplayFiltered.find(item => item.location?.lat !== 0 && item.location?.lng !== 0);
            if (mostRecentTest && mostRecentTest.location?.name) {
              this.center.lng = mostRecentTest.location.lng;
              this.center.lat = mostRecentTest.location.lat;
              this.zoom = 10;
            }
          }
        } else {
          if (this.userRole === 'admin') {
            this.orgFiltersChosen = [this.userOrgId];
          }
          if (this.orgFiltersChosen[0]) {
            await this.getFilteredOrgUsers();
          }
          this.dateFilterChosen = this.timestamp - 2592000;
          await this.getUserPlacesArray(this.uid);
        }

        await this.refreshTests();
      } else {
        await this.router.navigate(['/']);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.searchTermSubscription) {
      this.searchTermSubscription.unsubscribe();
    }
    if (this.itemsSubscription) {
      this.itemsSubscription.unsubscribe();
    }
  }

  updateSearchTerm($event) {
    this.searchTerm$.next($event.target.value);
    this.filterNote = $event.target.value;
    this.refreshTests();
  }

  downloadRawData() {
    const zip = new JSZip();

    const addFilesToZip = async () => {
      for (const rawData of this.arrayRawData) {
        for (const stage of rawData) {
          console.log(stage);
          const arrayBuffer = await this.getArrayBufferFromBlob(stage.blob);
          zip.file(stage.name, arrayBuffer);
        }
      }

      zip.generateAsync({ type: 'blob' })
        .then((content) => {
          const zipFile = new Blob([content], { type: 'application/zip' });
          const zipUrl = URL.createObjectURL(zipFile);
          const link = document.createElement('a');
          link.href = zipUrl;
          link.download = 'archive.zip';
          link.click();
          URL.revokeObjectURL(zipUrl);
        })
        .catch((error) => {
          console.error('Ошибка при генерации архива: ', error);
        });
    };

    addFilesToZip();
  }

  async getArrayBufferFromBlob(blob: Blob): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result as ArrayBuffer);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(blob);
    });
  }

  // check if location is a string or empty object (for some reason)
  isString(location): boolean {
    return typeof location === 'string';
  }

  selectLocation(event) {
    this.locationSelected = event.value;
    this.refreshTests();
  }

  selectWaterSource(event) {
    this.waterSourceSelected = event.value;
    this.refreshTests();
  }

  bacteria100LevelToColorCategory(bacteriaLevel: number) {
    if (bacteriaLevel < 100){
      // Below detection limit (< 100 CFU/ml)
      return 0;
    } else if (bacteriaLevel >= 100 && bacteriaLevel <= 500) {
      // Low (100 to 500 CFU/ml)
      return 'Low';
    } else if (bacteriaLevel > 500 && bacteriaLevel <= 2000) {
      // Low (500 to 2000 CFU/ml)
      return 'Low';
    } else if (bacteriaLevel > 2000 && bacteriaLevel <= 5000) {
      // Medium (2000 to 5000 CFU/ml)
      return 'Medium';
    }  else if (bacteriaLevel > 5000) {
      // High (>5000 CFU/ml)
      return 'High';
    }
  }

  bacteriaLevelToColorCategory(bacteriaLevel: number) {
    if (bacteriaLevel < 500){
      // Below detection limit (< 500 CFU/ml)
      return 0;
    } else if (bacteriaLevel >= 500 && bacteriaLevel <= 2000) {
      // Low (500 to 2000 CFU/ml)
      return 'Low';
    } else if (bacteriaLevel > 2000 && bacteriaLevel <= 5000) {
      // Medium (2000 to 5000 CFU/ml)
      return 'Medium';
    } else if (bacteriaLevel > 5000) {
      // High (>5000 CFU/ml)
      return 'High';
    }
  }

  ecoliLevelToColorCategory(eColiLevel: number) {
    if (eColiLevel < 1){
      // Below detection limit 1 CFU/10ml<
      return 0;
    } else if (eColiLevel > 1000) {
      // Low (500 to 2000 CFU/ml)
      return 'High';
    } else {
      return 'Low';
    }
  }

  h202AndChlorineLevelToColorCategory(disinfectantLevel: number) {
    if (disinfectantLevel < 10) {
      // H2O2 level: <10 PPM
      return 0;
    } else if (disinfectantLevel > 100) {
      // H2O2 level: >100 PPM
      return 'Low';
    }
  }

  async refreshTests(pageLimit = 10, pageSetup?, doc?) {

    this.testListLoaded = true;
    this.testDataTrue = true;
    this.testChartDataTrue = true;

    if (this.displayedTestsSubscription) {
      this.displayedTestsSubscription.unsubscribe();
    }

    const testApiBody = {
      filters: {
        testTypes: this.typeFiltersChosen[0] ? this.typeFiltersChosen : undefined,
        users: this.userFiltersChosen[0] ? this.userFiltersChosen : undefined,
        note: this.filterNote,
        // tslint:disable-next-line:max-line-length
        date: this.dateFilterChosen !== undefined && this.dateFilterChosen !== null ? this.dateFilterChosen : (this.timestamp - 2592000),
        orgUsers: this.orgUsersFiltersChosen[0] ? this.orgUsersFiltersChosen : undefined,
        location: this.locationSelected,
        water_source: this.waterSourceSelected,
      },
      viewLimit: this.show,
      pageLimit,
      pageSetup,
      doc
    };

    let tests;
    if (this.filterNote) {
      tests = await this.apiService.getTestDataSearchNote(testApiBody, this.idToken);
    } else {
      tests = await this.apiService.getTestDataPagination(testApiBody, this.idToken);
    }

    this.length = tests.allPages;
    this.ALL_ITEMS_OPTION = this.length;
    this.pageSizeOptions = [];
    const defaultPageSizeOptions = [5, 10, 25, 50, 100];
    defaultPageSizeOptions.map(value => {
      if (value < this.length) {
        this.pageSizeOptions.push(value);
      }
    });
    this.pageSizeOptions.push(this.ALL_ITEMS_OPTION);
    this.itemsToDisplay = tests.data;
    if (this.isAdmin) {
      this.itemsToDisplay.map((value) => {
        this.arrayRawData.push(this.ebi.downloadRawData(value, true));
      });
    }
    this.dataSource = this.itemsToDisplay;
    this.itemsToDisplayFiltered = this.itemsToDisplay;
    const cfv = tests.cfv;
    this.zone.runOutsideAngular(() => {
      am4core.useTheme(am4themes_animated);
      const chartGyr = am4core.create('chart-gyr', am4charts.PieChart);
      let countLow = 0;
      let countMedium = 0;
      let countHigh = 0;
      const bacteria = [];
      const bacteria100 = [];
      const chlorine = [];
      const h2o2 = [];
      const ecoli = [];
      const c19 = [];
      const legionella = [];
      const unknown = [];

      cfv.forEach(item => {
        if (item.bacteriaLevel > 15000 ||
          item.disinfectantLevel > 15000 ||
          item.eColiLevel > 15000 ||
          item.legionellaLevel > 15000) {
        }
        if (item.testType === 'bacteria' && item.bacteriaLevel > 0 && item.bacteriaLevel < 15000) {
          item.date = new Date(item.date._seconds * 1000);
          bacteria.push(item);
          if (this.bacteriaLevelToColorCategory(item.bacteriaLevel) === 'Low') {
            countLow++;
          }
          if (this.bacteriaLevelToColorCategory(item.bacteriaLevel) === 'Medium') {
            countMedium++;
          }
          if (this.bacteriaLevelToColorCategory(item.bacteriaLevel) === 'High') {
            countHigh++;
          }
        }
        if (item.testType === 'bacteria_100' && item.bacteriaLevel > 0 && item.bacteriaLevel < 15000) {
          item.date = new Date(item.date._seconds * 1000);
          bacteria100.push(item);
          if (this.bacteria100LevelToColorCategory(item.bacteriaLevel) === 'Low') {
            countLow++;
          }
          if (this.bacteriaLevelToColorCategory(item.bacteriaLevel) === 'Medium') {
            countMedium++;
          }
          if (this.bacteriaLevelToColorCategory(item.bacteriaLevel) === 'High') {
            countHigh++;
          }
        }
        if (item.testType === 'chlorine' && item.disinfectantLevel > 0 && item.disinfectantLevel < 15000) {
          item.date = new Date(item.date._seconds * 1000);
          chlorine.push(item);
          if (this.h202AndChlorineLevelToColorCategory(item.disinfectantLevel) === 'Low' ) {
            countLow++;
          }
        }
        if (item.testType === 'h2o2' && item.disinfectantLevel > 0 && item.disinfectantLevel < 15000) {
          item.date = new Date(item.date._seconds * 1000);
          h2o2.push(item);
          if (this.h202AndChlorineLevelToColorCategory(item.disinfectantLevel) === 'Low' ) {
            countLow++;
          }
        }
        if (item.testType === 'ecoli' && item.eColiLevel > 0 && item.eColiLevel < 15000) {
          item.date = new Date(item.date._seconds * 1000);
          ecoli.push(item);
          if (this.ecoliLevelToColorCategory(item.eColiLevel) === 'Low') {
            countLow++;
          }
          if (this.ecoliLevelToColorCategory(item.eColiLevel) === 'High') {
            countHigh++;
          }
        }
        if (item.testType === 'c19') { }
        if (item.testType === 'legionella' && item.legionellaLevel > 0 && item.legionellaLevel < 15000) {
          item.date = new Date(item.date._seconds * 1000);
          legionella.push(item);
        }
        if (item.testType === 'unknown') { }
      });

      chartGyr.data = [
        { category: 'Low', value: countLow, color: am4core.color('#2fba88') },
        { category: 'Medium', value: countMedium, color: am4core.color('#f4b740') },
        { category: 'High', value: countHigh, color: am4core.color('#f84051') },
        // tslint:disable-next-line:max-line-length
        { category: 'Below/Over Detection Limit', value: cfv.length - (countLow + countMedium + countHigh), color: am4core.color('#4f4e4e') }
      ];
      const seriesGyr = chartGyr.series.push(new am4charts.PieSeries());
      seriesGyr.dataFields.value = 'value';
      seriesGyr.dataFields.category = 'category';
      seriesGyr.dataFields.hidden = 'hidden';
      seriesGyr.labels.template.disabled = true;
      seriesGyr.ticks.template.disabled = true;
      seriesGyr.slices.template.propertyFields.fill = 'color';
      chartGyr.innerRadius = am4core.percent(40);
      chartGyr.legend = new am4charts.Legend();
      chartGyr.legend.position = 'right';

      if (!cfv.length) {
        this.testDataTrue = false;
      }
      if (!bacteria.length && !bacteria100.length && !chlorine.length && !h2o2.length && !ecoli.length && !legionella.length) {
        this.testChartDataTrue = false;
      }
      const chartCfm = am4core.create('chart-cfm', am4charts.XYChart);
      chartCfm.legend = new am4charts.Legend();
      chartCfm.legend.position = 'right';
      chartCfm.cursor = new am4charts.XYCursor();
      const dateAxis = chartCfm.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.labels.template.rotation = -90;
      dateAxis.renderer.labels.template.verticalCenter = 'middle';
      dateAxis.renderer.labels.template.horizontalCenter = 'left';
      dateAxis.renderer.grid.template.location = 0;
      dateAxis.renderer.minGridDistance = 40;
      dateAxis.dateFormats.setKey('day', 'yyyy-MM-dd');
      dateAxis.periodChangeDateFormats.setKey('day', 'yyyy-MM-dd');
      const valueAxis = chartCfm.yAxes.push(new am4charts.ValueAxis());
      valueAxis.tooltip.disabled = true;
      valueAxis.renderer.minWidth = 20;
      valueAxis.max = 15000;

      if (bacteria.length) {
        const bacteriaSeries = chartCfm.series.push(new am4charts.ColumnSeries());
        bacteriaSeries.dataFields.dateX = 'date';
        bacteriaSeries.dataFields.valueY = 'bacteriaLevel';
        bacteriaSeries.strokeWidth = 1;
        bacteriaSeries.data = bacteria;
        bacteriaSeries.stroke = am4core.color('#4D7594');
        bacteriaSeries.name = 'bacteria';
        bacteriaSeries.tooltipText = `Test type: {name}\nValue: {valueY}cfv/m\nDate: {dateX.formatDate(\'yyyy-MM-dd h:mm:ss\')}`;
        bacteriaSeries.tooltip.pointerOrientation = 'vertical';
      }
      if (bacteria100.length) {
        const bacteria100Series = chartCfm.series.push(new am4charts.ColumnSeries());
        bacteria100Series.dataFields.dateX = 'date';
        bacteria100Series.dataFields.valueY = 'bacteriaLevel';
        bacteria100Series.strokeWidth = 1;
        bacteria100Series.data = bacteria100;
        bacteria100Series.stroke = am4core.color('#E3A19F');
        bacteria100Series.name = 'bacteria_100';
        bacteria100Series.tooltipText = `Test type: {name}\nValue: {valueY}cfv/m\nDate: {dateX.formatDate(\'yyyy-MM-dd h:mm:ss\')}`;
        bacteria100Series.tooltip.pointerOrientation = 'vertical';
      }
      if (chlorine.length) {
        const chlorineSeries = chartCfm.series.push(new am4charts.ColumnSeries());
        chlorineSeries.dataFields.dateX = 'date';
        chlorineSeries.dataFields.valueY = 'disinfectantLevel';
        chlorineSeries.strokeWidth = 1;
        chlorineSeries.data = ecoli;
        chlorineSeries.stroke = am4core.color('#8ABBE0');
        chlorineSeries.name = 'chlorine';
        chlorineSeries.tooltipText = `Test type: {name}\nValue: {valueY}cfv/m\nDate: {dateX.formatDate(\'yyyy-MM-dd h:mm:ss\')}`;
        chlorineSeries.tooltip.pointerOrientation = 'vertical';
      }
      if (h2o2.length) {
        const h2o2Series = chartCfm.series.push(new am4charts.ColumnSeries());
        h2o2Series.dataFields.dateX = 'date';
        h2o2Series.dataFields.valueY = 'disinfectantLevel';
        h2o2Series.strokeWidth = 1;
        h2o2Series.data = ecoli;
        h2o2Series.stroke = am4core.color('#DFE075');
        h2o2Series.name = 'h2o2';
        h2o2Series.tooltipText = `Test type: {name}\nValue: {valueY}cfv/m\nDate: {dateX.formatDate(\'yyyy-MM-dd h:mm:ss\')}`;
        h2o2Series.tooltip.pointerOrientation = 'vertical';
      }
      if (ecoli.length) {
        const ecoliSeries = chartCfm.series.push(new am4charts.ColumnSeries());
        ecoliSeries.dataFields.dateX = 'date';
        ecoliSeries.dataFields.valueY = 'eColiLevel';
        ecoliSeries.strokeWidth = 1;
        ecoliSeries.data = ecoli;
        ecoliSeries.stroke = am4core.color('#939454');
        ecoliSeries.name = 'ecoli';
        ecoliSeries.tooltipText = `Test type: {name}\nValue: {valueY}cfv/m\nDate: {dateX.formatDate(\'yyyy-MM-dd h:mm:ss\')}`;
        ecoliSeries.tooltip.pointerOrientation = 'vertical';
      }
      if (legionella.length) {
        const legionellaSeries = chartCfm.series.push(new am4charts.ColumnSeries());
        legionellaSeries.dataFields.dateX = 'date';
        legionellaSeries.dataFields.valueY = 'legionellaLevel';
        legionellaSeries.strokeWidth = 1;
        legionellaSeries.data = ecoli;
        legionellaSeries.stroke = am4core.color('#947254');
        legionellaSeries.name = 'legionella';
        legionellaSeries.tooltipText = `Test type: {name}\nValue: {valueY}cfv/m\nDate: {dateX.formatDate(\'yyyy-MM-dd h:mm:ss\')}`;
        legionellaSeries.tooltip.pointerOrientation = 'vertical';
      }
    });

    if (!this.showArchivedTests) {
      this.itemsToDisplayFiltered = this.itemsToDisplayFiltered.filter(test => test.isArchived !== true);
    }

    if (this.displayMap) {
      this.loadMarkers();
      const mostRecentTest = this.itemsToDisplayFiltered.find(item => item.location?.lat !== 0 && item.location?.lng !== 0);

      if (mostRecentTest && mostRecentTest.location?.name) {
        this.center.lng = mostRecentTest.location.lng;
        this.center.lat = mostRecentTest.location.lat;
        this.zoom = 10;
      }
    }

    this.dataSource = this.itemsToDisplayFiltered;
    this.resultsString = this.itemsToDisplayFiltered.length === 1 ? 'result' : 'results';

    this.getTestFiltersData();

    if (!this.showArchivedTests) {
      this.itemsToDisplay = this.itemsToDisplay.filter(test => test.isArchived !== true);
    }

    this.testListLoaded = true;

    if (!this.userListDisplayed) {
      await this.getUserListData();
      if (this.userRole === 'superuser') {
        await this.getOrgListData();
      }
    }

    this.setCache();
    this.selectedItem = null;
  }

  resetPaginator() {
    this.paginator.pageIndex = 0;
  }

  onPageChanged(event) {
    const pageNumber = event.pageIndex;
    this.pageLimit = event.pageSize;
    let pageSetup;
    let doc;

    if (this.currentPage === pageNumber) {
      this.refreshTests(this.pageLimit);
      return;
    }

    if (this.currentPage < pageNumber) {
      pageSetup = 'next';
      doc = this.itemsToDisplay[this.itemsToDisplay.length - 1];
    } else {
      pageSetup = 'prew';
      doc = this.itemsToDisplay[0];
    }
    this.currentPage = pageNumber;
    this.refreshTests(this.pageLimit, pageSetup, doc);
  }

  viewDetail(t) {
    this.selectedItem = t;
  }

  updateTest(test) {
    const testId = test.calculationResult.testId;
    this.firestore.doc('/testResults/' + testId).update(test);
  }

  async handleNoteChange($event: Event, testId: string, uid: string) {
    const target = $event.target as HTMLInputElement; // Specifying $event.target type to avoid weird typing error
    const data = {
      note: target.value
    };
    await this.apiService.updateTestData(data, testId, uid, this.idToken);
  }

  async handleWaterSourceChange($event: Event, testId: string, uid: string) {
    const target = $event.target as HTMLInputElement; // Specifying $event.target type to avoid weird typing error
    const data = {
      'location.waterSource': target.value
    };
    await this.apiService.updateTestData(data, testId, uid, this.idToken);
  }

  async getUserSavedPlaces(uid: string, idToken: string) {
    const userData = await this.apiService.getUserData(uid, idToken);
    const userCustomClaims = await this.apiService.getUserCustomClaims(idToken, uid);
    const userOrgId = userCustomClaims.orgData?.orgId || '0';
    const userOrgData = await this.apiService.getOrgData(this.idToken, userOrgId);

    let userSavedPlaces = userData.data.places ? userData.data.places : [];
    let userSavedWaterSources = userData.data.waterSources ? userData.data.waterSources : [];

    if ((this.userRole === 'admin' && userOrgData.sharingLocations) || this.userRole === 'superuser') {
      const userList = await this.apiService.getOrgUsers(this.idToken, userOrgId);
      const orgPlacesArray = [];
      const orgWaterSourcesArray = [];

      for (const orgUser of userList) {
        if (orgUser.userData?.uid !== uid) {
          const places = orgUser.userData?.places;
          const sources = orgUser.userData?.waterSources;

          if (places) {
            orgPlacesArray.push(places);
          }
          if (sources) {
            orgWaterSourcesArray.push(sources);
          }
        }
      }
      for (const orgPlaces of orgPlacesArray) {
        userSavedPlaces = userSavedPlaces.concat(orgPlaces);
      }
      for (const orgSources of orgWaterSourcesArray) {
        userSavedWaterSources = userSavedWaterSources.concat(orgSources);
      }

    }
    this.currentUserSavedPlaces = userSavedPlaces;
    this.currentUserSavedWaterSources = userSavedWaterSources;
  }

  async editItemLocation($event: MouseEvent, item) {
    item.isEditingLocation = true;
    await this.getUserPlacesArray(item.uid);
  }

  async getUserPlacesArray(uid: string) {
    await this.getUserSavedPlaces(uid, this.idToken);
  }

  async editItemWaterSource($event: MouseEvent, item) {
    item.isEditing = true;
    await this.getUserPlacesArray(item.uid);
  }

  async getUserListData() {
    // tslint:disable-next-line:max-line-length
    const allUsers = this.userRole === 'superuser' ? await this.apiService.getAllUsers(this.idToken) : await this.apiService.getOrgUsers(this.idToken, this.userOrgId);
    for (const user of allUsers) {
      const itemUid = this.userRole === 'superuser' ? user.uid.toString() : user.userRecord.uid.toString();
      if (!this.userFilterList[itemUid]) {
        try {
          const data = this.userRole === 'superuser' ? await this.apiService.getUserData(itemUid, this.idToken) : {data: user.userData};
          if (Object.keys(data).length > 0) {
            this.userFilterList[itemUid] = data;
          }
          // This is to create a new user entry in firestore
          // else {
          //   const userData = {
          //     uid: itemUid,
          //     orgId: '0',
          //     active: true,
          //     displayName: user.email,
          //     email: user.email,
          //     places: [],
          //     waterSources: []
          //   };
          //   const userRef = this.firestore.collection('users').doc(itemUid);
          //
          //   const res = await userRef.set(userData, {merge: true});
          //   // await this.apiService.updateUserDetails(data, itemUid, this.idToken);
          //
          // }
        } catch (e) {
          console.log(e);
        }
      }


    }
    this.userListDisplayed = this.userFilterList;
    this.usersLoaded = true;
  }

  async clearFilters() {
    const uncheck = document.getElementsByTagName('input');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < uncheck.length; i++) {
      if (uncheck[i].type === 'checkbox' || uncheck[i].type === 'radio') {
        uncheck[i].checked = false;
      }
    }
    this.clearDateInputs();
    await this.handleFilterClick();
  }

  clearDateRadios() {
    const uncheck = document.getElementsByTagName('input');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < uncheck.length; i++) {
      if (uncheck[i].type === 'radio') {
        uncheck[i].checked = false;
      }
    }
    // this.handleFilterClick();

  }

  clearDateInputs() {
    const startDateInput = document.getElementById('start') as HTMLInputElement;
    const startDateInputDrawerMap = document.getElementById('start-drawer-map') as HTMLInputElement;
    const endDateInput = document.getElementById('end') as HTMLInputElement;
    const endDateInputDrawerMap = document.getElementById('end-drawer-map') as HTMLInputElement;
    if (startDateInput) {
      startDateInput.setAttribute('max', '');
      startDateInput.value = '';

    }
    if (endDateInput) {
      endDateInput.setAttribute('min', '');
      endDateInput.value = '';

    }
    if (startDateInputDrawerMap) {
      startDateInputDrawerMap.setAttribute('max', '');
      startDateInputDrawerMap.value = '';

    }
    if (endDateInputDrawerMap) {
      endDateInputDrawerMap.setAttribute('min', '');
      endDateInputDrawerMap.value = '';

    }

  }

  getTestFiltersData() {
    if (this.itemsToDisplayFiltered) {
      this.dateFilters = {
        '7_days': 0,
        '30_days': 0,
        '6_months': 0,
        '1_year': 0
      };
      this.locationsList = [];
      this.waterSourcesList = [];
      this.itemsToDisplayFiltered.forEach(item => {
        if (item.location?.name && !this.locationsList.includes(item.location?.name)) {
          this.locationsList.push(item.location?.name);
        }
        if (item.location?.waterSource && !this.waterSourcesList.includes(item.location?.waterSource)) {
          this.waterSourcesList.push(item.location?.waterSource);
        }

        if (!this.typeFilters[item.calculationResult.testType]) {
          this.typeFilters[item.calculationResult.testType] = 1;

        } else {
          this.typeFilters[item.calculationResult.testType]++;
        }
        if (item.calculationResult.date?.seconds > this.timestamp - 604800) {
          this.dateFilters['1_year']++;
          this.dateFilters['6_months']++;
          this.dateFilters['30_days']++;
          this.dateFilters['7_days']++;
        } else if (item.calculationResult.date?.seconds > this.timestamp - 2592000 || item.date?.seconds > this.timestamp - 2592000) {
          this.dateFilters['1_year']++;
          this.dateFilters['6_months']++;
          this.dateFilters['30_days']++;
        } else if (item.calculationResult.date?.seconds > this.timestamp - 15780000 || item.date?.seconds > this.timestamp - 15780000) {
          this.dateFilters['1_year']++;
          this.dateFilters['6_months']++;
        } else if (item.calculationResult.date?.seconds > this.timestamp - 31536000 || item.date?.seconds > this.timestamp - 31536000) {
          this.dateFilters['1_year']++;
        }
      });
    }
  }

  swichSchedule() {
    this.showScheduleTests = !this.showScheduleTests;
    console.log(this.showScheduleTests);
  }

  async handleFilterClick() {
    this.currentPage = 0;
    this.resetPaginator();
    if (this.testListLoaded) {
      this.testListLoaded = false;
    }
    this.typeFiltersChosen = [];
    this.userFiltersChosen = [];
    this.orgFiltersChosen = this.userRole === 'admin' ? [this.userOrgId] : [];
    this.orgUsersFiltersChosen = [];
    this.dateFilterChosen = null;
    this.userListDisplayed = this.userFilterList;
    this.showArchivedTests = false;
    const check = document.getElementsByTagName('input');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < check.length; i++) {
      if (check[i].checked) {
        if (check[i].type === 'checkbox' && check[i].className.includes('archived-checkbox')) {
          this.showArchivedTests = true;
        }
        if (check[i].type === 'checkbox' && check[i].className.includes('type-checkbox')) {
          this.typeFiltersChosen.push(check[i].value);
        }
        if (check[i].type === 'checkbox' && check[i].className.includes('user-checkbox')) {
          this.userFiltersChosen.push(check[i].value);
        }
        if (check[i].type === 'checkbox' && check[i].className.includes('org-checkbox')) {
          this.orgFiltersChosen.push(check[i].value);
          this.userListDisplayed = Object.keys(this.userListDisplayed).reduce(function(r, e) {
            if (this.userFilterList[e].data?.orgId?.toLowerCase() === check[i].value.toLowerCase()) {
              r[e] = this.userListDisplayed[e];
            }
            return r;
          }.bind(this), {});
        }
        if (check[i].type === 'radio') {
          this.dateFilterChosen = Number(check[i].value);
          this.clearDateInputs();

        }
      }
    }
    if (this.orgFiltersChosen[0]) {
      await this.getFilteredOrgUsers();
    }
    await this.refreshTests();
  }

  filterDisplayedItems() {

    this.itemsToDisplayFiltered = this.itemsToDisplay;
    this.resultsString = this.itemsToDisplay.length === 1 ? 'result' : 'results';
    if (this.displayMap) {
      this.loadMarkers();
    }
  }

  async navigateToTest(testId: string) {
    await this.router.navigate(['/test' + '/' + testId]);
  }

  removeIsEditing(item) {
    if (item.isEditing) {
      item.isEditing = false;
    }
    if (item.isEditingLocation) {
      item.isEditingLocation = false;
    }
  }

  searchItems(value) {
    const filterValue = value;
    this.itemsToDisplayFiltered = this.itemsToDisplay;
    this.filterDisplayedItems();
    this.itemsToDisplayFiltered = this.itemsToDisplayFiltered.filter(item => {
      return (
        item.calculationResult.testType.toLowerCase().includes(filterValue.toLowerCase()) ||
        item.location?.name?.toLowerCase().includes(filterValue.toLowerCase()) ||
        item.location?.formatted_address?.toLowerCase().includes(filterValue.toLowerCase()) ||
        item.note?.toLowerCase().includes(filterValue.toLowerCase()) ||
        item.location?.waterSource?.toLowerCase().includes(filterValue.toLowerCase()) ||
        item.waterSource?.toLowerCase().includes(filterValue.toLowerCase())
      );
    });
    if (this.displayMap) {
      this.loadMarkers();
    }
  }


  async handleStartDateChange($event: Event) {
    this.clearDateRadios();
    const target = $event.target as HTMLInputElement;
    const timestamp = target.valueAsNumber / 1000;
    const endDateInput = document.getElementById('end') as HTMLInputElement;
    this.itemsToDisplayFiltered = this.itemsToDisplay.filter(item => item.calculationResult.date.seconds >= timestamp);
    this.dataSource = this.itemsToDisplayFiltered;
    endDateInput.setAttribute('min', target.value);
    await this.refreshTests();
  }

  async handleEndDateChange($event: Event) {
    this.clearDateRadios();
    const target = $event.target as HTMLInputElement;
    const startDateInput = document.getElementById('start') as HTMLInputElement;
    const timestamp = target.valueAsNumber / 1000;
    this.itemsToDisplayFiltered = this.itemsToDisplay.filter(item => item.calculationResult.date.seconds <= timestamp);
    this.dataSource = this.itemsToDisplayFiltered;
    startDateInput.setAttribute('max', target.value);
    await this.refreshTests();
  }

  async openDrawer() {
    this.drawerOpened = true;
    await this.drawer.toggle();
  }

  async closeDrawer() {
    this.mobileDrawerOpened = false;
    this.drawerOpened = false;
    await this.drawer.toggle();
  }

  mapInteract(location, testId) {
    const lat = location.lat;
    const lng = location.lng;
    if (lat === 0 && lng === 0) { // custom location or no location
      return;
    }
    let markerEl;
    const markerInfo = this.markers.find(marker => {
      return marker.position.lat === lat &&
        marker.position.lng === lng &&
        marker.title === location.name &&
        marker.id === testId;
    });
    markerEl = this.markerElements.find(markerInstance => {
      return markerInstance.getPosition().lat() === lat &&
        markerInstance.getPosition().lng() === lng &&
        markerInstance.getTitle() === location.name;
    });
    this.openInfo(markerEl, markerInfo.info);
    this.map.panTo({lat, lng});
    this.zoom = 10;
  }

  openInfo(marker: MapMarker, markerInfo) {
    this.markerUrl = '/test/' + markerInfo.testId;
    this.infoContent = '<div class="text-capitalize font-weight-bold mb-2">' + markerInfo.testType + ' test</div>' +
      '<div class="pb-1 marker-header">DATE & TIME</div>' +
      '<h4 class="mb-1 marker-info">' + markerInfo.date + '</h4>' +
      '<div class="pb-1 marker-header">LOCATION</div>' +
      '<h4 class="mb-1 marker-info">' + markerInfo.location + '</h4>' +
      '<div class="pb-1 marker-header">RESULT</div>' +

      '<h4 class="mb-1 marker-info">' + markerInfo.result + '</h4>' +
      '<a href=' + this.markerUrl + '>View Details</a>';
    this.infoWindow.open(marker);
  }

  loadMarkers() {
    this.markers = [];
    for (const item of this.itemsToDisplayFiltered) {
      if (item.location?.name && item.location?.lat !== 0 && item.location?.lng !== 0) {

        this.markers.push({
          id: item.calculationResult.testId,
          position: {
            lat: item.location.lat,
            lng: item.location.lng
          },
          label: {
            color: 'blue',
            text: item.location.name || item.location,
            className: 'mb-5'
          },
          title: item.location.name || item.location,
          options: {
            animation: google.maps.Animation.DROP,
            icon: './assets/icon.png'
          },
          info: {
            date: new Date(item.calculationResult.date.seconds * 1000).toLocaleDateString('en-US'),
            testId: item.calculationResult.testId,
            location: item.location.name || item.location,
            result: item.calculationResult.textDescription,
            testType: item.calculationResult.testType
          }
        });
      }
    }
  }

  async navigateToLocation(placeId: string, itemUid: string) {
    let itemOrg;
    if (this.userListDisplayed[itemUid]) {
      itemOrg = this.userListDisplayed[itemUid].data.orgId;
    } else {
      const userData = await this.apiService.getUserData(itemUid, this.idToken);
      itemOrg = userData.data.orgId;
    }
    if (itemOrg !== this.userOrgId) {
      await this.router.navigate(['/location/', placeId], {state: {itemOrg}});
    } else {
      await this.router.navigate(['/location/', placeId]);
    }
  }

  async infiniteScrollToggled() {
    if (this.itemsToDisplayFiltered) {
      if (this.displayedTestsSubscription) {
        this.displayedTestsSubscription.unsubscribe();
      }
      this.show += 10;
      await this.refreshTests();
    }
  }

  updateUserFilterSearchTerm($event) {
    this.userSearchTerm$.next($event.target.value);
  }

  updateOrgFilterSearchTerm($event) {
    this.orgSearchTerm$.next($event.target.value);
  }

  private searchUsers(filterValue) {
    this.userListDisplayed = this.userFilterList;
    const userListEntries = Object.keys(this.userListDisplayed);
    this.userListDisplayed = Object.keys(this.userListDisplayed).reduce(function(r, e) {
      if (this.userListDisplayed[e].data?.uid?.toLowerCase().includes(filterValue.toLowerCase()) ||
        this.userListDisplayed[e].data?.displayName?.toLowerCase().includes(filterValue.toLowerCase()) ||
        this.userListDisplayed[e].data?.email?.toLowerCase().includes(filterValue.toLowerCase())) {
        r[e] = this.userListDisplayed[e];
      }
      return r;
    }.bind(this), {});
  }

  private searchOrgs(filterValue) {
    this.orgListDisplayed = this.orgFilterList;
    const orgListEntries = Object.keys(this.orgListDisplayed);
    this.orgListDisplayed = Object.keys(this.orgListDisplayed).reduce(function(r, e) {
      if (this.orgListDisplayed[e].id?.toLowerCase().includes(filterValue.toLowerCase()) ||
        this.orgListDisplayed[e].name?.toLowerCase().includes(filterValue.toLowerCase())) {
        r[e] = this.orgListDisplayed[e];
      }
      return r;
    }.bind(this), {});
  }

  private async getFilteredOrgUsers() {
    for (const orgId of this.orgFiltersChosen) {
      const data = await this.apiService.getOrgUsers(this.idToken, orgId);
      for (const user of data) {
        this.orgUsersFiltersChosen.push(user.userRecord.uid);
      }
    }
  }

  private async  getOrgListData() {
    const allOrgs = await this.apiService.getAllOrgs(this.idToken);
    for (const org of allOrgs) {
      const orgId = org.id.toString();
      if (!this.orgFilterList[orgId]) {
        try {
          const data = await this.apiService.getOrgData(this.idToken, orgId);
          if (Object.keys(data).length > 0) {
            this.orgFilterList[orgId] = data;
          }
        } catch (e) {
        }
      }
    }
    this.orgListDisplayed = this.orgFilterList;
    this.orgsLoaded = true;
  }

  private setCache() {
    if (!this.itemsToDisplayFiltered) {
      return;
    }
    this.cacheService.itemsToDisplayFiltered = this.itemsToDisplayFiltered;
    this.cacheService.itemsToDisplay = this.itemsToDisplay;
    this.cacheService.dateFilterChosen = this.dateFilterChosen;
    this.cacheService.orgUsersFiltersChosen = this.orgUsersFiltersChosen;
    this.cacheService.typeFiltersChosen = this.typeFiltersChosen;
    this.cacheService.userFiltersChosen = this.userFiltersChosen;
    this.cacheService.orgFiltersChosen = this.orgFiltersChosen;
    this.cacheService.currentUserSavedPlaces = this.currentUserSavedPlaces;
    this.cacheService.currentUserSavedWaterSources = this.currentUserSavedWaterSources;
    this.cacheService.userFilterList = this.userFilterList;
    this.cacheService.orgFilterList = this.orgFilterList;
    this.cacheService.resultsString = this.resultsString;
    this.cacheService.markers = this.markers;
    this.cacheService.testListCached = true;
  }

  private getCache() {
    this.itemsToDisplayFiltered = this.cacheService.itemsToDisplayFiltered;
    this.itemsToDisplay = this.cacheService.itemsToDisplay;
    this.dateFilterChosen = this.cacheService.dateFilterChosen;
    this.orgUsersFiltersChosen = this.cacheService.orgUsersFiltersChosen;
    this.typeFiltersChosen = this.cacheService.typeFiltersChosen;
    this.userFiltersChosen = this.cacheService.userFiltersChosen;
    this.orgFiltersChosen = this.cacheService.orgFiltersChosen;
    this.currentUserSavedPlaces = this.cacheService.currentUserSavedPlaces;
    this.currentUserSavedWaterSources = this.cacheService.currentUserSavedWaterSources;
    this.userFilterList = this.cacheService.userFilterList;
    this.orgFilterList = this.cacheService.orgFilterList;
    this.userListDisplayed = this.userFilterList;
    this.resultsString = this.cacheService.resultsString;
    this.usersLoaded = true;
    this.orgListDisplayed = this.orgFilterList;
    this.orgsLoaded = true;
    if (this.displayMap) {
      this.markers = this.cacheService.markers;
    }
    this.testListLoaded = true;
  }

  async drawerToggle() {
    await this.drawer.toggle();
    this.mobileDrawerOpened = true;
  }

  showTestType(testType: string) {
    return this.userRole === 'superuser' ||
      // tslint:disable-next-line:max-line-length
      (this.userFirestoreData?.data.customTestsEnabled && this.userFirestoreData?.data.enabledTests.includes(testType) && !this.userFirestoreData?.data.hiddenTests.includes(testType)) ||
      // tslint:disable-next-line:max-line-length
      (!this.userFirestoreData?.data.customTestsEnabled && this.userOrgData?.enabledTests.includes(testType) && !this.userOrgData?.hiddenTests.includes(testType));
  }

  public downloadCSV() {
    this.ebiService.downloadCSV(this.itemsToDisplay);
  }

  public downloadPDF() {
    this.ebiService.createTestsPdf(this.itemsToDisplay);
  }

  enableEditingUser() {
    this.isEditingUser = true;
  }

  setEditingLocationOff(item: any) {
    item.isEditingLocation = false;
  }

  pureArray(array: Array<string>): Array<string> {
    return array.filter(str => str !== '' && str !== null);
  }
}
